import {EventLogShowService} from '../services/event-log-show.service';
import {EventLogService} from '../services/crud/event-log.service';
import {PdfGeneratorService} from '../services/pdf-generator.service';
import {EmailPreviewService} from '../services/email-preview-service';
import {UserEmailTemplatesService} from '../services/crud/user-email-templates.service';
import {ConfigService, CountryService} from '../services';
import {AuthGuard} from '../guards/auth.guard';
import {CommonModule, DatePipe} from '@angular/common';
import {CdkTableModule} from '@angular/cdk/table';
import {RouterModule} from '@angular/router';
import {ShowEventLogsDialogComponent} from '../shared/show-event-logs-dialog/show-event-logs-dialog.component';
import {ShowDialogComponent} from '../shared/show-dialog/show-dialog.component';
import {ConfirmDialogComponent} from '../shared/confirm-dialog/confirm-dialog.component';
import {UserConfigComponent} from './administration/configs/user-config/user-config.component';
import {InvoicesConfigsComponent} from './administration/configs/invoices-configs/invoices-configs.component';
import {EventLogViewComponent} from '../shared/event-log-view/event-log-view.component';
import {ObjectCommentsViewComponent} from '../shared/object-comments-view/object-comments-view.component';
import {
  UserEmailTemplatesEditComponent
} from './administration/templates/user-email-templates/user-email-templates-edit/user-email-templates-edit.component';
import {
  UserEmailTemplatesComponent
} from './administration/templates/user-email-templates/user-email-templates.component';
import {TemplatesComponent} from './administration/templates/templates.component';
import {UserComponent} from './administration/users/user/user.component';
import {HtmlEditorComponent} from '../shared/html-editor/html-editor.component';
import {GrapesjsEditorComponent} from '../shared/grapesjs-editor/grapesjs-editor.component';
import {ConfigsComponent} from './administration/configs/configs.component';
import {MatTableGeneratorComponent} from '../shared/mat-table-generator/mat-table-generator.component';
import {FileUploadComponent} from '../shared/file-upload/file-upload.component';
import {FileUploadXlsComponent} from '../shared/file-upload-xls/file-upload-xls.component';
import {AdministrationComponent} from './administration/administration.component';
import {UsersComponent} from './administration/users/users.component';
import {ReportsComponent} from './reports/reports.component';
import {HomeComponent} from './home.component';
import {HeadComponent} from './head/head.component';
import {homeRoutes} from './home.router';
import {NgModule} from '@angular/core';
import {LibsModule} from '../libs.module';
import {EmailConfigComponent} from './administration/configs/email-config/email-config.component';
import {RoleGuard} from '../guards/role.guard';
import {RoleService} from '../services/role.service';
import {HasRolesDirective} from '../directives/has-roles/has-roles.directive';
import {CardsComponent} from './cards/cards.component';
import {CustomersOverviewComponent} from './customers-overview/customers-overview.component';
import {SendEmailComponent} from './send-email/sendemail.component';
import {NewEditSendMailComponent} from './send-email/new-edit-sendmail/new-edit-sendmail.component';
import {CustomersComponent} from './customers/customers.component';
import {CardsService} from './services/cards.service';
import {CustomersService} from './services/customers.service';
import {CompaniesComponent} from './companies/companies.component';
import {CompanyViewComponent} from './companies/company-view/company-view.component';
import {CompanyEditComponent} from './companies/company-edit/company-edit.component';
import {ProductsComponent} from './products/products.component';
import {ProductViewComponent} from './products/product-view/product-view.component';
import {ProductEditComponent} from './products/product-edit/product-edit.component';
import {CardViewComponent} from './cards/card-view/card-view.component';
import {CardEditComponent} from './cards/card-edit/card-edit.component';
import {CustomerViewComponent} from './customers/customer-view/customer-view.component';
import {CustomerEditComponent} from './customers/customer-edit/customer-edit.component';
import {DateInputDirective} from '../directives/date-input/date-input.directive';
import {OrderImportsComponent} from './orders/order-imports/order-imports.component';
import {OrderImportViewComponent} from './orders/order-imports/order-import-view/order-import-view.component';
import {OrderImportsService} from './services/order-imports.service';
import {InvoicesComponent} from './invoices/invoices.component';
import {InvoiceViewComponent} from './invoices/invoice-view/invoice-view.component';
import {InvoiceEditComponent} from './invoices/invoice-edit/invoice-edit.component';
import {PaymentImportViewComponent} from './payment-import/payment-import-view/payment-import-view.component';
import {PaymentImportComponent} from './payment-import/payment-import.component';
import {PaymentImportService} from './services/payment-import.service';
import {
  SofortTransactionImportViewComponent
} from './soforts/sofort-transaction-imports/sofort-transaction-import-view/sofort-transaction-import-view.component';
import {
  SofortTransactionImportsComponent
} from './soforts/sofort-transaction-imports/sofort-transaction-imports.component';
import {SofortTransactionImportsService} from './services/sofort-transaction-imports.service';
import {
  SofortStatementImportViewComponent
} from './soforts/sofort-statement-imports/sofort-statement-import-view/sofort-statement-import-view.component';
import {SofortStatementImportsComponent} from './soforts/sofort-statement-imports/sofort-statement-imports.component';
import {SofortStatementImportsService} from './services/sofort-statement-imports.service';
import {SofortsComponent} from './soforts/soforts.component';
import {SepaImportViewComponent} from './sepas/sepa-imports/sepa-import-view/sepa-import-view.component';
import {SepaImportComponent} from './sepas/sepa-imports/sepa-imports.component';
import {SepaImportService} from './services/sepa-import.service';
import {SepasComponent} from './sepas/sepas.component';
import {OrdersComponent} from './orders/orders.component';
import {OrderViewComponent} from './orders/order-view/order-view.component';
import {OrderEditComponent} from './orders/order-edit/order-edit.component';
import {CardActivationImportService} from './services/card-activation-import.service';
import {CardCreationImportService} from './services/card-creation-import.service';
import {CardActivationImportsComponent} from './orders/card-activations/card-activation-imports.component';
import {
  CardActivationImportViewComponent
} from './orders/card-activations/card-activation-import-view/card-activation-import-view.component';
import {
  CardCreationImportViewComponent
} from './orders/card-creations/card-activation-import-view/card-creation-import-view.component';
import {CardCreationImportsComponent} from './orders/card-creations/card-creation-imports.component';
import {FileImportDialogComponent} from '../shared/file-import-dialog/file-import-dialog.component';
import {OrderCancelDialogComponent} from '../shared/order-cancel-dialog/order-cancel-dialog.component';
import {
  OrderEmailTemplatesComponent
} from './administration/templates/order-email-templates/order-email-templates.component';
import {
  OrderEmailTemplatesEditComponent
} from './administration/templates/order-email-templates/order-email-templates-edit/order-email-templates-edit.component';
import {
  InvoiceEmailTemplatesComponent
} from './administration/templates/invoice-email-templates/invoice-email-templates.component';
import {
  InvoiceEmailTemplatesEditComponent
} from './administration/templates/invoice-email-templates/invoice-email-templates-edit/invoice-email-templates-edit.component';
import {
  InvoicePdfTemplatesComponent
} from './administration/templates/invoice-pdf-templates/invoice-pdf-templates.component';
import {
  InvoicePdfTemplatesEditComponent
} from './administration/templates/invoice-pdf-templates/invoice-pdf-templates-edit/invoice-pdf-templates-edit.component';
import {
  EmailReminderTypeComponent
} from './administration/configs/email-reminder-types/email-reminder-type/email-reminder-type.component';
import {
  EmailReminderTypesComponent
} from './administration/configs/email-reminder-types/email-reminder-types.component';
import {MyAccountComponent} from './my-account/my-account.component';
import {ChangePasswordComponent} from './my-account/change-password/change-password.component';
import {SentRemindersComponent} from './orders/order-view/sent-reminders/sent-reminders.component';
import {VoucherOrderComponent} from './vouchers/voucher-orders.component';
import {VoucherOrderAddComponent} from './vouchers/voucher-order-add/voucher-order-add.component';
import {VoucherOrderViewComponent} from './vouchers/voucher-order-view/voucher-order-view.component';
import {OtherTemplatesComponent} from './administration/templates/other-templates/other-templates.component';
import {
  OtherTemplatesEditComponent
} from './administration/templates/other-templates/other-templates-edit/other-templates-edit.component';
import {
  ReminderDistributionComponent
} from './administration/reminders/reminder-distribution/reminder-distribution.component';
import {RemindersComponent} from './administration/reminders/reminders.component';
import {DebtorsComponent} from './administration/debtors/debtors.component';
import {DebtorDistributionComponent} from './administration/debtors/debtor-distribution/debtor-distribution.component';
import {
  DebtorServiceConfigComponent
} from './administration/configs/debtor-service-config/debtor-service-config.component';
import {FeeServiceConfigComponent} from './administration/configs/fee-service-config/fee-service-config.component';
import {FeesComponent} from './administration/fees/fees.component';
import {CardReorderDialogComponent} from '../shared/card-reorder-dialog/card-reorder-dialog.component';
import {OrderConfigComponent} from './administration/configs/order-config/order-config.component';
import {WebIdConfigComponent} from './administration/configs/web-id-config/web-id-config.component';
import {
  CustomerOverviewDetailComponent
} from './customers-overview/customer-overview-detail/customer-overview-detail.component';
import {ResendWebidDialogComponent} from '../shared/resend-webid/resend-webid-dialog.component';
import {SendUploadLinkDialogComponent} from '../shared/send-upload-link/send-upload-link-dialog.component';

import {TotalCardOrdersComponent} from './total-card-orders/total-card-orders.component';
import {TotalCardOrderViewComponent} from './total-card-orders/total-card-order-view/total-card-order-view.component';
import {CustomerConfigComponent} from './administration/configs/customer-config/customer-config.component';
import {
  CustomerEmailTemplatesEditComponent
} from './administration/templates/customer-email-templates/customer-email-templates-edit/customer-email-templates-edit.component';
import {
  CustomerEmailTemplatesComponent
} from './administration/templates/customer-email-templates/customer-email-templates.component';
import {IdvCustomersOverviewComponent} from './idv-customers-overview/idv-customers-overview.component';
import {
  IdvCustomerOverviewDetailComponent
} from './idv-customers-overview/customer-overview-detail/idv-customer-overview-detail.component';
import {TriStateCheckboxComponent} from '../shared/tri-state-checkbox/tri-state-checkbox.component';
import {OrdersCancellationsInternComponent} from './orders-cancellations-intern/orders-cancellations-intern.component';
import {OrdersCancellationsInternService} from './services/orders-cancellations-intern.service';
import {
  OrdersCancellationsInternDetailComponent
} from './orders-cancellations-intern/orders-cancellations-intern-detail/orders-cancellations-intern-detail.component';
import {
  TotalCardEmailTemplatesEditComponent
} from './administration/templates/total-card-email-templates/total-card-email-templates-edit/total-card-email-templates-edit.component';
import {
  TotalCardEmailTemplatesComponent
} from './administration/templates/total-card-email-templates/total-card-email-templates.component';
import {TotalCardOrderEmailTemplatesService} from './services/total-card-order-email-templates.service';
import {
  TotalCardOrderConfigComponent
} from './administration/configs/total-card-order-config/total-card-order-config.component';

import {CardRenewalComponent} from './cards/card-renewal/card-renewal.component';
import {CardRenewalViewComponent} from './cards/card-renewal/card-renewal-view/card-renewal-view.component';
import {DynamicScriptLoaderService} from '../services/dynamicScriptLoader.service';
import {
  InvoicesPaidConfigsComponent
} from './administration/configs/invoices-paid-configs/invoices-paid-configs.component';
import {CardbroGatewayService} from './services/cardbro-gateway.service';
import {
  CardholderDetailsDialogComponent
} from '../shared/cardholder-details-dialog/cardholder-details-dialog.component';
import {ChangeEmailDialogComponent} from '../shared/change-email-dialog/change-email-dialog.component';
import {
  ChangeCustomerPhoneDialogComponent
} from '../shared/change-customer-phone-dialog/change-customer-phone-dialog.component';
import {AddressCustomersService} from './services/address-customers.service';
import {AddressCustomersOverviewComponent} from './address-customers-overview/address-customers-overview.component';
import {
  AddressCustomerOverviewDetailComponent
} from './address-customers-overview/address-overview-detail/address-customer-overview-detail.component';
import {SmsOrderTemplatesComponent} from './administration/templates/sms-order-templates/sms-order-templates.component';
import {
  OrderSmsTemplatesEditComponent
} from './administration/templates/sms-order-templates/order-sms-templates-edit/order-sms-templates-edit.component';
import {OrderSmsTemplatesService} from './services/order-sms-templates.service';
import {CustomerEmailLogViewComponent} from '../shared/customer-email-log-view/customer-email-log-view.component';
import {CardCancellationDialogComponent} from '../shared/card-cancellation-dialog/card-cancellation-dialog.component';
import {CustomerInvoiceLogViewComponent} from '../shared/customer-invoice-log-view/customer-invoice-log-view.component';
import {
  ImportTotalTransactionsComponent
} from './total-card-orders/import-transactions/import-total-transactions.component';
import {TotalCardOrderService} from '../order-assistant/services/total-card-order.service';
import {
  TotalStatsImportViewComponent
} from './total-card-orders/import-transactions/total-stats-import-view/total-stats-import-view.component';
import {PaymentReportComponent} from './payment-report/payment-report.component';
import {InvoicesReportService} from './services/invoices-report.service';
import {TwoDigitDecimaNumberDirective} from '../directives/text-input/two-digit-decimal.directive';
import {RevolutComponent} from './sepas/revolut.component';
import {RevolutService} from './services/revolut.service';
import {RevolutDetailsComponent} from './sepas/revolut-detail/revolut-details.component';
import {RiskComponent} from './risk/risk.component';
import {RiskService} from './services/risk.service';
import {RiskCheckComponent} from './risk/risk-check/risk-check.component';
import {RiskOverviewService} from './services/risk-overview.service';
import {RiskCheckDetailComponent} from './risk/risk-check-detail/risk-check-detail.component';
import {CompanyApiSettingsComponent} from './companies/company-api-settings/company-api-settings.component';
import {AddApikeyDialogComponent} from './companies/company-api-settings/add-apikey-dialog/add-apikey-dialog.component';
import {
  DisplayApikeyDialogComponent
} from './companies/company-api-settings/display-apikey-dialog/display-apikey-dialog.component';
import {LoadsComponent} from './loads/loads.component';
import {BtlComponent} from './btl/btl.component';
import {TransactionViewComponent} from './btl/transaction-view/transaction-view.component';
import {BtlViewComponent} from './btl/btl-view/btl-view.component';
import {BtlEditComponent} from './btl/btl-edit/btl-edit.component';
import {LastLoadFilesComponent} from './btl/last-load-files/last-load-files.component';
import {GpsLoadResponseUploadComponent} from './btl/gps-load-response-upload/gps-load-response-upload.component';
import {PepComponent} from './pep/pep.component';
import {PepCheckService} from './services/pep-check.service';
import {LoadNavComponent} from '../shared/load-nav/load-nav.component';
import {ComplianceNavComponent} from '../shared/comliance-nav/compliance-nav.component';
import {BadgeService} from './services/badge.service';
import {NgxFlagIconCssModule} from 'ngx-flag-icon-css';
import {GpsLoadResponseHistoryService} from './services/gps-load-response-history.service';
import {GpsHistoryComponent} from './btl/gps-history/gps-history.component';
import {ShowDialogWithLinkComponent} from '../shared/show-dialog-with-link/show-dialog-with-link.component';
import {NgxDropzoneModule} from 'ngx-dropzone';
import {WalletViewComponent} from './partner-wallet/wallet-view/wallet-view.component';
import {LoadsApprovalComponent} from './partner-wallet/loads-approval/loads-approval.component';
import {WalletListComponent} from './partner-wallet/wallet-list/wallet-list.component';
import {LoadDetailComponent} from './partner-wallet/load-detail/load-detail.component';
import {LoadDialogComponent} from './partner-wallet/load-dialog/load-dialog.component';
import {
  BalanceAdjustmentDialogComponent
} from './partner-wallet/balance-adjustment-dialog/balance-adjustment-dialog.component';
import {
  UploadPartnerLoadsFileDialogComponent
} from './partner-wallet/upload-partner-loads-file-dialog/upload-partner-loads-file-dialog.component';
import {
  UploadLoadsFileResultsDialogComponent
} from './partner-wallet/upload-loads-file-results-dialog/upload-loads-file-results-dialog.component';
import {AngularToastifyModule, ToastService} from 'angular-toastify';
import {ContentRowComponent} from '../shared/content-row/content-row.component';
import {LoadRefundsComponent} from './btl/load-refunds/load-refunds.component';
import {LoadRefundsViewComponent} from './btl/load-refunds/load-refunds-view/load-refunds-view.component';
import {LoadStatusInfoComponent} from './btl/load-status-info/load-status-info.component';
import {TransferFundsDialogComponent} from './partner-wallet/transfer-funds-dialog/transfer-funds-dialog.component';
import {
  DownloadStatementDialogComponent
} from './partner-wallet/download-statement-dialog/download-statement-dialog.component';
import {CreateWalletDialogComponent} from './partner-wallet/create-wallet-dialog/create-wallet-dialog.component';
import {BankTransferRefundService} from './services/bank-transfer-refund.service';
import {EditWalletDialogComponent} from './partner-wallet/edit-wallet-dialog/edit-wallet-dialog.component';
import {LoadRefundsHistoryComponent} from './btl/load-refunds/load-refunds-history/load-refunds-history.component';
import {MatBadgeModule} from '@angular/material/badge';
import { OrderExportAllComponent } from './orders/order-export-all/order-export-all.component';
import { UploadLoadDocumentsDialogComponent } from './partner-wallet/upload-load-documents-dialog/upload-load-documents-dialog.component';
import { ViewWalletTransactionComponent } from './partner-wallet/view-wallet-transaction/view-wallet-transaction.component';
import { InviteWalletUserDialogComponent } from './partner-wallet/invite-wallet-user-dialog/invite-wallet-user-dialog.component';
import { PendingInvitesComponent } from './partner-wallet/pending-invites/pending-invites.component';
import { PendingInviteDetailComponent } from './partner-wallet/pending-invite-detail/pending-invite-detail.component';
import { WalletUserViewComponent } from './partner-wallet/wallet-user-view/wallet-user-view.component';
import { SofBtlDetailComponent } from './sof/sof-btl-detail/sof-btl-detail.component';
import { SofGenericDetailComponent } from './sof/sof-generic-detail/sof-generic-detail.component';
import { TemplateSendPreviewDialogComponent } from './shared/template-send-preview-dialog/template-send-preview-dialog.component';
import { CashbackGroupsComponent } from './administration/cashback-groups/cashback-groups.component';
import { CashbackGroupsEditComponent } from './administration/cashback-groups/cashback-groups-edit/cashback-groups-edit.component';
import { CashbackGroupsDetailComponent } from './administration/cashback-groups/cashback-groups-detail/cashback-groups-detail.component';
import { AddCashbackGroupDialogComponent } from './administration/cashback-groups/add-cashback-group-dialog/add-cashback-group-dialog.component';
import { AddCardToCashbackGroupDialogComponent } from './administration/cashback-groups/add-card-to-cashback-group-dialog/add-card-to-cashback-group-dialog.component';
import { PartnerCounterComponent } from './partner-counter/partner-counter.component';
import { PartnerCounterCreateInvoiceComponent } from './partner-counter/partner-counter-create-invoice/partner-counter-create-invoice.component';
import { PartnerCounterIndexComponent } from './partner-counter/partner-counter-index/partner-counter-index.component';
import { PartnerCounterInvoiceDetailComponent } from './partner-counter/partner-counter-invoice-detail/partner-counter-invoice-detail.component';
import { CustomerIdentEditDialogComponent } from './customers/customer-ident-edit-dialog/customer-ident-edit-dialog.component';
import { NextAnnualFeesComponent } from './next-annual-fees/next-annual-fees.component';
import { NextCardExpiriesComponent } from './next-card-expiries/next-card-expiries.component';
import { LastCardActivitiesComponent } from './last-card-activities/last-card-activities.component';
import { BlockedCardsComponent } from './risk/blocked-cards/blocked-cards.component';
import { DormantCardsComponent } from './risk/dormant-cards/dormant-cards.component';
import { ActivateTotpComponent } from './my-account/activate-totp/activate-totp.component';
import { MustActivateMfaComponent } from './my-account/must-activate-mfa/must-activate-mfa.component';
import { CollectionSearchComponent } from './collection-search/collection-search.component';
import { CollectionSearchDetailComponent } from './collection-search-detail/collection-search-detail.component';
import { RedirectRoleDeciderComponent } from './redirect-role-decider/redirect-role-decider.component';
import { ReferralsComponent } from './referrals/referrals.component';
import { ReferralViewComponent } from './referrals/referral-view/referral-view.component';
import { ReferralEditComponent } from './referrals/referral-edit/referral-edit.component';
import { ReordersQueuedComponent } from './reorders/reorders-queued/reorders-queued.component';
import {CardExtensionDialogComponent} from '../shared/card-extension-dialog/card-extension-dialog.component';
import { PendingExtensionsComponent } from './orders/pending-extensions/pending-extensions.component';
import {
  StatusChangeReasonDialogComponent
} from '../shared/status-change-reason-dialog/status-change-reason-dialog.component';
import { PendingConversionsComponent } from './orders/pending-conversions/pending-conversions.component';
import { OtherTemplatesAddComponent } from './administration/templates/other-templates/other-templates-add/other-templates-add.component';
import { CardCreationsComponent } from './orders/card-creations/card-creations.component';
import { CardCreationsDetailComponent } from './card-creations/card-creations-detail/card-creations-detail.component';
import { CustomerCashbackViewComponent } from './customers-overview/customer-cashback-view/customer-cashback-view.component';
import {
  AddressConfirmDialogComponent
} from "../shared/confirm-dialog/address-confirm-dialog/address-confirm-dialog.component";
import {NgxChartsModule} from "@swimlane/ngx-charts";
import { TrustpayUsercheckComponent } from './trustpay-usercheck/trustpay-usercheck.component';
import {TypeSafeMatCellDef} from "../directives/type-safe-matcelldef/type-safe-matcelldef";
import { CcediComponent } from './ccedi/ccedi.component';
import { MarketingStatisticsComponent } from './marketing-statistics/marketing-statistics.component';
import { MicroPaymentComponent } from './micro-payment/micro-payment.component';

import { InvoicingNavComponent } from './shared/invoicing-nav/invoicing-nav.component';
import {
  MicroPaymentSessionDetailComponent
} from "./micro-payment/micro-payment-session-detail/micro-payment-session-detail.component";
import { AnnualFeeDeductionsComponent } from './annual-fee-deductions/annual-fee-deductions.component';
import { AnnualFeeDeductionDetailComponent } from './annual-fee-deductions/annual-fee-deduction-detail/annual-fee-deduction-detail.component';
import {CompaniesNavComponent} from "../shared/companies-nav/companies-nav.component";
import {OrdersNavComponent} from "../shared/orders-nav/orders-nav.component";
import {OrdersBadgeService} from "./services/orders-badge.service";
import {
  IncludeSecondariesDialogComponent
} from "../shared/include-secondaries-dialog/include-secondaries-dialog.component";
import {GiftCardsComponent} from "./giftcards/gift-cards.component";
import {GiftCardDetailsComponent} from "./giftcards/gift-card-details/gift-card-details.component";
import {GiftCardBrandsComponent} from "./giftcards/gift-card-brands/gift-card-brands.component";
import {GiftCardBrandDetailsComponent} from "./giftcards/gift-card-brand-details/gift-card-brand-details.component";
import {FinancialStatisticsComponent} from "./financial-statistics/financial-statistics.component";
import {
  AnnualFeeStatisticsComponent
} from "./financial-statistics/annual-fee-statistics/annual-fee-statistics.component";
import {CashbackStatisticsComponent} from "./financial-statistics/cashback-statistics/cashback-statistics.component";
import {
  TransactionStatisticsComponent
} from "./financial-statistics/transaction-statistics/transaction-statistics.component";
import {
  RestoreAnonymizedDialogComponent
} from "./customers/restore-anonymized-dialog/restore-anonymized-dialog.component";
import {
  PushNotificationTemplatesComponent
} from "./administration/templates/push-notification-templates/push-notification-templates.component";
import {PushNotificationTemplatesService} from "../services/crud/push-notification-templates.service";
import {
  PushNotificationTemplatesEditComponent
} from "./administration/templates/push-notification-templates/push-notification-templates-edit/push-notification-templates-edit.component";
import {CustomerFcmLogsComponent} from "../shared/customer-fcm-logs/customer-fcm-logs.component";
import { EmojiListComponent } from './shared/emoji-list/emoji-list.component';
import { PushNotificationConfigsComponent } from './administration/configs/push-notification-configs/push-notification-configs.component';
import { PushNotificationLoadRemindersComponent } from './administration/configs/push-notification-configs/push-notification-load-reminders/push-notification-load-reminders.component';
import { PushNotificationCustomerConfigsComponent } from './administration/configs/push-notification-configs/push-notification-customer-configs/push-notification-customer-configs.component';
import { PushNotificationLoadConfigsComponent } from './administration/configs/push-notification-configs/push-notification-load-configs/push-notification-load-configs.component';
import {
  CustomerEmailLogViewContainerComponent
} from "../shared/customer-email-log-view-container/customer-email-log-view-container.component";
import {TplMonthlyReportComponent} from "./compliance/tpl-monthly-report/tpl-monthly-report.component";
import {
  CustomerAnnualFeeDeductionLogViewComponent
} from "../shared/customer-annual-fee-deduction-log-view/customer-annual-fee-deduction-log-view.component";
import {BadgeWithLoadingComponent} from "../shared/badge-with-loading/badge-with-loading.component";
import {
  CustomerMicropaymentSessionsViewComponent
} from "../shared/customer-micropayment-sessions-view/customer-micropayment-sessions-view.component";
import {
  CustomerWhitelistedBankaccountsViewComponent
} from "../shared/customer-whitelisted-bankaccounts-view/customer-whitelisted-bankaccounts-view.component";
import {
  WhiteListedSenderAccountsComponent
} from "./white-listed-sender-accounts/white-listed-sender-accounts.component";
import {
  WhiteListedSenderAccountDetailComponent
} from "./white-listed-sender-accounts/white-listed-sender-account-detail/white-listed-sender-account-detail.component";
import { ImagesComponent } from './administration/images/images.component';
import { ImageDetailComponent } from './administration/images/image-detail/image-detail.component';
import { ImageAlbumComponent } from './administration/images/image-album/image-album.component';
import { AnnualFeesComponent } from './annual-fees/annual-fees.component';
import { AnnualFeesPaidComponent } from './annual-fees/annual-fees-paid/annual-fees-paid.component';
import { AnnualFeeDetailComponent } from './annual-fees/annual-fee-detail/annual-fee-detail.component';
import { AnnualFeeEditComponent } from './annual-fees/annual-fee-edit/annual-fee-edit.component';
import {CustomerAnnualFeesViewComponent} from "./customer-annual-fees-view/customer-annual-fees-view.component";
import { PushNotificationReminderTypesComponent } from './administration/configs/push-notification-reminder-types/push-notification-reminder-types.component';
import { PushNotificationReminderTypeComponent } from './administration/configs/push-notification-reminder-types/push-notification-reminder-type/push-notification-reminder-type.component';
import { GiftCardBrandEditComponent } from './giftcards/gift-card-brand-edit/gift-card-brand-edit.component';
import {CustomerBadgesComponent} from "../customer-badges/customer-badges.component";
import {ChargebacksComponent} from "./chargebacks/chargebacks.component";
import {ChargebackDetailComponent} from "./chargebacks/chargeback-detail/chargeback-detail.component";
import {CardActivitiesComponent} from "./card-activities/card-activities.component";
import {CardActivitiesDetailComponent} from "./card-activities/card-activities-detail/card-activities-detail.component";
import {NumberInputComponent} from "../shared/number-input/number-input.component";
import { MarkVulnerableDialogComponent } from './customers/mark-vulnerable-dialog/mark-vulnerable-dialog.component';
import {ChooseDateDialogComponent} from "../shared/choose-date-dialog/choose-date-dialog.component";
import {SearchableMultiSelectComponent} from "./searchable-multi-select/searchable-multi-select.component";






@NgModule({
    declarations: [
        TypeSafeMatCellDef,
        PepComponent,
        GpsLoadResponseUploadComponent,
        RiskCheckDetailComponent,
        SmsOrderTemplatesComponent,
        OrderSmsTemplatesEditComponent,
        AddressCustomersOverviewComponent,
        AddressCustomerOverviewDetailComponent,
        InvoicesPaidConfigsComponent,
        HeadComponent,
        HomeComponent,
        ReportsComponent,
        UsersComponent,
        CompaniesComponent,
        CompanyEditComponent,
        CompanyViewComponent,
        ProductsComponent,
        ProductEditComponent,
        ProductViewComponent,
        ConfirmDialogComponent,
        ChooseDateDialogComponent,
        IncludeSecondariesDialogComponent,
        AddressConfirmDialogComponent,
        StatusChangeReasonDialogComponent,
        OrderCancelDialogComponent,
        ShowDialogComponent,
        AdministrationComponent,
        FileUploadComponent,
        FileUploadXlsComponent,
        MatTableGeneratorComponent,
        DateInputDirective,
        HasRolesDirective,
        TwoDigitDecimaNumberDirective,
        ConfigsComponent,
        HtmlEditorComponent,
        GrapesjsEditorComponent,
        UserComponent,
        TemplatesComponent,
        UserEmailTemplatesComponent,
        UserEmailTemplatesEditComponent,
        ShowEventLogsDialogComponent,
        EventLogViewComponent,
        CustomerEmailLogViewComponent,
        CustomerEmailLogViewContainerComponent,
        CustomerFcmLogsComponent,
        CustomerInvoiceLogViewComponent,
        CustomerAnnualFeesViewComponent,
        BadgeWithLoadingComponent,
        CustomerAnnualFeeDeductionLogViewComponent,
        CustomerMicropaymentSessionsViewComponent,
        CustomerWhitelistedBankaccountsViewComponent,
        ObjectCommentsViewComponent,
        UserConfigComponent,
        CustomerConfigComponent,
        InvoicesConfigsComponent,
        EmailConfigComponent,
        CustomersComponent,
        CustomersOverviewComponent,
        CardholderDetailsDialogComponent,
        SendEmailComponent,
        NewEditSendMailComponent,
        RiskComponent,
        CustomerOverviewDetailComponent,
        CardsComponent,
        CardViewComponent,
        CardEditComponent,
        OrdersComponent,
        SofortsComponent,
        SepasComponent,
        OrderViewComponent,
        OrderEditComponent,
        CustomerEditComponent,
        CustomerViewComponent,
        OrderImportsComponent,
        OrderImportViewComponent,
        CardActivationImportsComponent,
        CardActivationImportViewComponent,
        CardCreationImportsComponent,
        CardCreationImportViewComponent,
        InvoicesComponent,
        InvoiceViewComponent,
        InvoiceEditComponent,
        PaymentImportViewComponent,
        PaymentImportComponent,
        CardActivitiesComponent,
        NumberInputComponent,
        CardActivitiesDetailComponent,
        InvoiceEditComponent,
        PaymentReportComponent,
        RevolutComponent,
        RevolutDetailsComponent,
        SofortTransactionImportViewComponent,
        SofortTransactionImportsComponent,
        SofortStatementImportViewComponent,
        SofortStatementImportsComponent,
        SepaImportComponent,
        SepaImportViewComponent,
        FileImportDialogComponent,
        OrderEmailTemplatesComponent,
        OrderEmailTemplatesEditComponent,
        CustomerEmailTemplatesComponent,
        CustomerEmailTemplatesEditComponent,
        InvoiceEmailTemplatesComponent,
        InvoiceEmailTemplatesEditComponent,
        InvoicePdfTemplatesComponent,
        InvoicePdfTemplatesEditComponent,
        EmailReminderTypesComponent,
        EmailReminderTypeComponent,
        MyAccountComponent,
        ChangePasswordComponent,
        SentRemindersComponent,
        VoucherOrderComponent,
        VoucherOrderAddComponent,
        VoucherOrderViewComponent,
        OtherTemplatesComponent,
        OtherTemplatesEditComponent,
        RemindersComponent,
        ReminderDistributionComponent,
        DebtorsComponent,
        DebtorDistributionComponent,
        DebtorServiceConfigComponent,
        FeeServiceConfigComponent,
        FeesComponent,
        CardReorderDialogComponent,
        CardExtensionDialogComponent,
        CardCancellationDialogComponent,
        OrderConfigComponent,
        WebIdConfigComponent,
        TotalCardOrdersComponent,
        TotalCardOrderViewComponent,
        ResendWebidDialogComponent,
        SendUploadLinkDialogComponent,
        ShowDialogWithLinkComponent,
        ChangeEmailDialogComponent,
        IdvCustomersOverviewComponent,
        IdvCustomerOverviewDetailComponent,
        TriStateCheckboxComponent,
        LoadNavComponent,
        CompaniesNavComponent,
        OrdersNavComponent,
        ComplianceNavComponent,
        OrdersCancellationsInternComponent,
        OrdersCancellationsInternDetailComponent,
        TotalCardEmailTemplatesEditComponent,
        TotalCardEmailTemplatesComponent,
        TotalCardOrderConfigComponent,
        OrdersCancellationsInternDetailComponent,
        CardRenewalComponent,
        CardRenewalViewComponent,
        ChangeCustomerPhoneDialogComponent,
        ImportTotalTransactionsComponent,
        FileUploadXlsComponent,
        TotalStatsImportViewComponent,
        RiskCheckComponent,
        CompanyApiSettingsComponent,
        AddApikeyDialogComponent,
        DisplayApikeyDialogComponent,
        LoadsComponent,
        BtlComponent,
        TransactionViewComponent,
        BtlViewComponent,
        BtlEditComponent,
        LastLoadFilesComponent,
        GpsHistoryComponent,
        WalletViewComponent,
        LoadsApprovalComponent,
        WalletListComponent,
        LoadDetailComponent,
        LoadDialogComponent,
        BalanceAdjustmentDialogComponent,
        UploadPartnerLoadsFileDialogComponent,
        UploadLoadsFileResultsDialogComponent,
        ContentRowComponent,
        LoadRefundsComponent,
        LoadRefundsViewComponent,
        LoadStatusInfoComponent,
        TwoDigitDecimaNumberDirective,
        TransferFundsDialogComponent,
        DownloadStatementDialogComponent,
        CreateWalletDialogComponent,
        EditWalletDialogComponent,
        LoadRefundsHistoryComponent,
        OrderExportAllComponent,
        UploadLoadDocumentsDialogComponent,
        ViewWalletTransactionComponent,
        InviteWalletUserDialogComponent,
        PendingInvitesComponent,
        PendingInviteDetailComponent,
        WalletUserViewComponent,
        SofBtlDetailComponent,
        SofGenericDetailComponent,
        TemplateSendPreviewDialogComponent,
        CashbackGroupsComponent,
        CashbackGroupsEditComponent,
        CashbackGroupsDetailComponent,
        AddCashbackGroupDialogComponent,
        AddCardToCashbackGroupDialogComponent,
        RestoreAnonymizedDialogComponent,
        PartnerCounterComponent,
        PartnerCounterCreateInvoiceComponent,
        PartnerCounterIndexComponent,
        PartnerCounterInvoiceDetailComponent,
        CustomerIdentEditDialogComponent,
        MarkVulnerableDialogComponent,
        NextAnnualFeesComponent,
        NextCardExpiriesComponent,
        LastCardActivitiesComponent,
        BlockedCardsComponent,
        ChargebacksComponent,
        ChargebackDetailComponent,
        DormantCardsComponent,
        ActivateTotpComponent,
        MustActivateMfaComponent,
        CollectionSearchComponent,
        CollectionSearchDetailComponent,
        RedirectRoleDeciderComponent,
        ReferralsComponent,
        ReferralViewComponent,
        ReferralEditComponent,
        ReordersQueuedComponent,
        PendingExtensionsComponent,
        PendingConversionsComponent,
        OtherTemplatesAddComponent,
        PushNotificationTemplatesEditComponent,
        CardCreationsComponent,
        CardCreationsDetailComponent,
        CustomerCashbackViewComponent,
        TrustpayUsercheckComponent,
        CcediComponent,
        MarketingStatisticsComponent,
        FinancialStatisticsComponent,
        AnnualFeeStatisticsComponent,
        CashbackStatisticsComponent,
        TransactionStatisticsComponent,
        MicroPaymentComponent,
        MicroPaymentSessionDetailComponent,
        WhiteListedSenderAccountsComponent,
        WhiteListedSenderAccountDetailComponent,
        InvoicingNavComponent,
        AnnualFeeDeductionsComponent,
        AnnualFeeDeductionDetailComponent,
        GiftCardsComponent,
        GiftCardDetailsComponent,
        GiftCardBrandsComponent,
        GiftCardBrandDetailsComponent,
        PushNotificationTemplatesComponent,
        EmojiListComponent,
        PushNotificationConfigsComponent,
        PushNotificationLoadRemindersComponent,
        PushNotificationCustomerConfigsComponent,
        PushNotificationLoadConfigsComponent,
        TplMonthlyReportComponent,
        ImagesComponent,
        ImageDetailComponent,
        ImageAlbumComponent,
        AnnualFeesComponent,
        AnnualFeesPaidComponent,
        AnnualFeeDetailComponent,
        AnnualFeeEditComponent,
        PushNotificationReminderTypesComponent,
        PushNotificationReminderTypeComponent,
        GiftCardBrandEditComponent,
        CustomerBadgesComponent,
        MarkVulnerableDialogComponent,
      SearchableMultiSelectComponent,
    ],
  entryComponents: [
    ConfirmDialogComponent,
    IncludeSecondariesDialogComponent,
    AddressConfirmDialogComponent,
    StatusChangeReasonDialogComponent,
    ShowDialogComponent,
    ShowEventLogsDialogComponent,
    FileImportDialogComponent,
    OrderCancelDialogComponent,
    CardReorderDialogComponent,
    CardExtensionDialogComponent,
    CardCancellationDialogComponent,
    ResendWebidDialogComponent,
    SendUploadLinkDialogComponent,
    CardholderDetailsDialogComponent,
    ChangeEmailDialogComponent,
    ChangeCustomerPhoneDialogComponent,
    AddApikeyDialogComponent,
    DisplayApikeyDialogComponent,
    ShowDialogWithLinkComponent,
    LoadDialogComponent,
    BalanceAdjustmentDialogComponent,
    TransferFundsDialogComponent,
    UploadPartnerLoadsFileDialogComponent,
    UploadLoadsFileResultsDialogComponent,
    DownloadStatementDialogComponent,
    CreateWalletDialogComponent,
    EditWalletDialogComponent,
    UploadLoadDocumentsDialogComponent,
    InviteWalletUserDialogComponent,
    TemplateSendPreviewDialogComponent,
    AddCashbackGroupDialogComponent,
    AddCardToCashbackGroupDialogComponent,
    RestoreAnonymizedDialogComponent,
    CustomerIdentEditDialogComponent,
    SearchableMultiSelectComponent,
  ],
    imports: [
        LibsModule,
        CommonModule,
        RouterModule.forChild(homeRoutes),
        CdkTableModule,
        MatBadgeModule,
        NgxFlagIconCssModule,
        NgxDropzoneModule,
        AngularToastifyModule,
        NgxChartsModule,
    ],
  providers: [
    BadgeService,
    OrdersBadgeService,
    BankTransferRefundService,
    PepCheckService,
    RiskOverviewService,
    OrderSmsTemplatesService,
    AddressCustomersService,
    DynamicScriptLoaderService,
    RiskService,
    RevolutService,
    DatePipe,
    CardbroGatewayService,
    AuthGuard,
    CountryService,
    ConfigService,
    UserEmailTemplatesService,
    PushNotificationTemplatesService,
    TotalCardOrderEmailTemplatesService,
    PdfGeneratorService,
    EmailPreviewService,
    EventLogService,
    EventLogShowService,
    RoleGuard,
    RoleService,
    CardsService,
    CustomersService,
    PaymentImportService,
    SofortTransactionImportsService,
    SofortStatementImportsService,
    SepaImportService,
    OrderImportsService,
    CardActivationImportService,
    CardCreationImportService,
    OrdersCancellationsInternService,
    TotalCardOrderService,
    InvoicesReportService,
    GpsLoadResponseHistoryService,
    ToastService
  ],
  exports: [
    FileUploadComponent
  ],
  bootstrap: [HomeComponent]
})
export class HomeModule { }
